<template>
  <v-select
    v-model="item.color"
    clearable
    @change="selectColor"
    persistent-hint
    item-value="color.color"
    :hint="card.cardName"
    append-icon=""
    label="Filtrar"
    :items="card.extra.fab.list"
    dense
  >
    <template slot="selection" slot-scope="data">
      <v-layout ma-0>
        <v-flex pa-0>
          <!-- <img class="mx-1" slot="activator" height="14px" :src="require('@/' + data.item.color.iconPath)" alt="indicator-icon">         -->
          <v-icon style="font-size:18px;margin-right:8px" :color="data.item.color.color">fiber_manual_record</v-icon>
        </v-flex>
        <v-flex pa-0 xs12 text-xs-left>
          <span>{{ data.item.status }}</span>
        </v-flex>
      </v-layout>
    </template>
    <template slot="item" slot-scope="data">
      <v-layout>
        <!-- <img class="ma-1" slot="activator" height="16px" :src="require('@/' + data.item.color.iconPath)" alt="indicator-icon">         -->
        <v-icon style="font-size:18px;margin-right:8px" :color="data.item.color.color">fiber_manual_record</v-icon>
        <span>{{ data.item.status }}</span>
      </v-layout>
    </template>
  </v-select>
</template>

<script>
export default {
  data () {
    return {
      selection: ''
    }
  },
  methods: {
    selectColor (selectedItem) {
      this.item.color = selectedItem
    }
  },
  props: {
    card: {
      type: Object,
      default () {
        return {}
      }
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/supervisor/distributors-details-color-filter.vue